import { InitialState } from "./types"
import { StockDocumentDefinition, StockDocumentDefinitionListing } from "../models"

export const stateHandler = (state: InitialState) => {
    return {
        fetchListing: (): InitialState => {
            return {
                ...state,
                isLoading: true,
            }
        },

        fetchListingSuccess: (res: StockDocumentDefinitionListing): InitialState => {
            const formattedRes = res.data?.map((item) => {
                return {
                    id: item.id,
                    ...item.attributes,
                }
            }) ?? []

            let firstItem = {}
            if (formattedRes.length > 0) {
                firstItem = formattedRes[0]
            }

            return {
                ...state,
                ...firstItem,
                isLoaded: true,
                isLoading: false,
                listing: formattedRes
            }
        },

        setFromListing: (id: string): InitialState => {
            const item = state.listing?.find((item) => item.id === id)
            return {
                ...state,
                ...item,
            }
        },

        fetchSuccess: (res: StockDocumentDefinition) => {
            return {
                ...state,
                ...res.attributes,
                id: res.id,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/reducers/handler.ts